import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router';
import axios from 'axios';
import '../App.css';
import '../Login.css';
import { API_BASE_URL } from '../utils/apiConfig.js';
const Signup = () => {
    
    const [firstName, setfirstName] = useState("");
    const [lastName, setlastName] = useState("");
    const [organization, setOrganization] = useState("");
    const [researchObjective, setResearchObjective] = useState(""); 
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState(""); 
    const [message, setMessage] = useState("");
    // State to track input errors for highlighting
    const [errors, setErrors] = useState({}); 

    const navigate = useNavigate();

    // Helper function to validate all fields before submission
    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        const fields = { firstName, lastName, organization, researchObjective, email, password, confirmPassword };
        
        for (const [key, value] of Object.entries(fields)) {
            if (!value) {
                newErrors[key] = true;
                isValid = false;
            }
        }

        setErrors(newErrors);
        return isValid;
    };
    
    // Function that runs when an input loses focus 
    const handleBlur = (e) => {
        const { name, value } = e.target;
        
        // If empty, set error to true
        if (!value) {
            setErrors(prev => ({ ...prev, [name]: true }));
        } else {
            // If not empty, clear the error
            setErrors(prev => ({ ...prev, [name]: false }));
        }
        
        // Secondary check for password fields on blur
        if (name === 'confirmPassword' && password !== value) {
            setErrors(prev => ({ ...prev, password: true, confirmPassword: true }));
        }
    };

    async function handleSubmit(e) {
        e.preventDefault();
        setMessage("");
        setErrors({});

        // Check 1: Empty fields
        if (!validateForm()) {
            setMessage("Please fill in all required fields.");
            return;
        }
        // Check 2: passwords match
        if (password !== confirmPassword) {
            // Highlight only the password boxes for this specific error
            setErrors({ password: true, confirmPassword: true });
            setMessage("Ensure that passwords match.");
            return;
        }

        // Valid form is sent
        try {
            // Sends to the backend
            const response = await axios.post(`${API_BASE_URL}/api/signup`, {
                firstName, lastName, organization, researchObjective, email, password 
            });

            // Handles 200/201 success status
            if (response.status >= 200 && response.status < 300) {
                setMessage("Success! Awaiting sponsor approval. Check the console for the approval link.");
                // Redirect user after success 
                setTimeout(() => {
                    navigate("/login"); 
                }, 4000);
            }

        } catch (error) {
            // Handles 409 (Email exists) and 500 errors
            if (error.response && error.response.data && error.response.data.message) {
                setMessage(error.response.data.message);
            } else {
                setMessage("An error occurred during signup.");
            }
        }
    };

    return (
        <div className="login-page">
            <div className="login-container signup-container"> {/* Added 'signup-container' class */}
                <div className="login-card">
                    <h2 className="login-title">Create Account</h2>
                    <p className="login-subtext">Fill out the form to become a researcher</p>
                    {message && <p className="login-message">{message}</p>}
                    
                    <form onSubmit={handleSubmit} noValidate>
                        
                        {/* ROW 1: Names */}
                        <div className="form-row">
                            <div className="form-group">
                                <label>First Name</label>
                                <input 
                                    type="text" name="firstName" value={firstName}
                                    onBlur={handleBlur} onChange={(e) => setfirstName(e.target.value)}
                                    placeholder="First Name" required 
                                    className={errors.firstName ? 'input-error' : ''} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Last Name</label>
                                <input 
                                    type="text" name="lastName" value={lastName}
                                    onBlur={handleBlur} onChange={(e) => setlastName(e.target.value)}
                                    placeholder="Last Name" required 
                                    className={errors.lastName ? 'input-error' : ''} 
                                />
                            </div>
                        </div>

                        {/* ROW 2: Email & Organization */}
                        <div className="form-row">
                            <div className="form-group">
                                <label>Email</label>
                                <input 
                                    type="email" name="email" value={email}
                                    onBlur={handleBlur} onChange={(e) => setEmail(e.target.value)}
                                    placeholder="you@example.com" required 
                                    className={errors.email ? 'input-error' : ''} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Organization</label>
                                <input 
                                    type="text" name="organization" value={organization}
                                    onBlur={handleBlur} onChange={(e) => setOrganization(e.target.value)}
                                    placeholder="Enter your organization" required 
                                    className={errors.organization ? 'input-error' : ''} 
                                />
                            </div>
                        </div>
                        
                        {/* ROW 3: Research Objective (Full Width) */}
                        <div className="form-group">
                            <label>Research Focus</label>
                            <textarea 
                                name="researchObjective" value={researchObjective}
                                onBlur={handleBlur} onChange={(e) => setResearchObjective(e.target.value)}
                                placeholder="e.g., We aim to test how ‘low sugar’ labels affect product choice probability." 
                                rows="3" required 
                                className={errors.researchObjective ? 'input-error' : ''} 
                            ></textarea>
                        </div>

                        {/* ROW 4: Passwords */}
                        <div className="form-row">
                            <div className="form-group">
                                <label>Password</label>
                                <input 
                                    type="password" name="password" value={password}
                                    onBlur={handleBlur} onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Create password" required 
                                    className={errors.password ? 'input-error' : ''} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Confirm</label>
                                <input 
                                    type="password" name="confirmPassword" value={confirmPassword}
                                    onBlur={handleBlur} onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm password" required 
                                    className={errors.confirmPassword ? 'input-error' : ''} 
                                />
                            </div>
                        </div>

                        <button className="submit-btn" type="submit">Sign Up</button>
                    </form>

                    <p className="signup-text">
                        Already have an account? <Link to="/login" className="signup-link">Log In</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Signup;